"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PsqHelper = void 0;
var constants = require("./Constants");
var PsqHelper = (function () {
    function PsqHelper() {
    }
    PsqHelper.getLabel = function (psq) { return "" + psq.text + (psq.isRequired ? constants.ASTERISK : ''); };
    return PsqHelper;
}());
exports.PsqHelper = PsqHelper;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/shared/code/PsqHelper.ts
// module id = 76
// module chunks = 0